import { render, staticRenderFns } from "./Greets.vue?vue&type=template&id=0135cbd6&scoped=true"
import script from "./Greets.vue?vue&type=script&lang=js"
export * from "./Greets.vue?vue&type=script&lang=js"
import style0 from "./Greets.vue?vue&type=style&index=0&id=0135cbd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0135cbd6",
  null
  
)

export default component.exports